import React, { createContext, useContext, useState, ReactNode } from 'react'

const defaultFormData: IFormData = {
    nationalCode: '',
    phoneNumber: '',
    serialCode: '',
    nationalCardPhoto: null,
    photo: null,
    video: null,
}

const FormContext = createContext<IFormContextProps | undefined>(undefined)

export const FormProvider: React.FC<{ children: ReactNode }> = ({
    children,
}) => {
    const [formData, setFormData] = useState<IFormData>(defaultFormData)

    const resetFormData = () => setFormData(defaultFormData)

    return (
        <FormContext.Provider value={{ formData, setFormData, resetFormData }}>
            {children}
        </FormContext.Provider>
    )
}

export const useFormContextData = () => {
    const context = useContext(FormContext)
    if (!context) {
        throw new Error('useFormData must be used within a FormProvider')
    }
    return context
}
